import apiClient from '../utils/api/ApiClient';
import { API_ENDPOINTS } from '../constants/api.constants';
import type {
    TriggerStoreEventRequest,
    TriggerStoreEventResponse,
    TriggerAllUsersEventRequest,
    TriggerAllUsersEventResponse,
    GetUnsyncedOrdersRequest,
    GetUnsyncedOrdersResponse,
    DeleteUnsyncedOrdersRequest,
    DeleteUnsyncedOrdersResponse,
    UpdateUnsyncedOrdersRequest,
    UpdateUnsyncedOrdersResponse,
    UnsyncedOrder,
} from '../types/api.types';

export const triggerStoreEvent = async (
    request: TriggerStoreEventRequest,
    storeBrandId: string
): Promise<TriggerStoreEventResponse> => {
    return apiClient.post<TriggerStoreEventResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.TRIGGER_STORE_EVENT,
        request,
        { headers: { 'X-Store-Brand-Id': storeBrandId } }
    );
};

export const triggerAllUsersEvent = async (
    request: TriggerAllUsersEventRequest,
    storeBrandId: string
): Promise<TriggerAllUsersEventResponse> => {
    return apiClient.post<TriggerAllUsersEventResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.TRIGGER_ALL_USERS_EVENT,
        request,
        { headers: { 'X-Store-Brand-Id': storeBrandId } }
    );
};

export const getUnsyncedOrders = async (
    request: GetUnsyncedOrdersRequest,
    storeBrandId: string
): Promise<UnsyncedOrder[]> => {
    const response = await apiClient.post<GetUnsyncedOrdersResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.GET_UNSYNCED_ORDERS,
        request,
        { headers: { 'X-Store-Brand-Id': storeBrandId } }
    );
    return response.data?.orders || [];
};

export const deleteUnsyncedOrders = async (
    request: DeleteUnsyncedOrdersRequest,
    storeBrandId: string
): Promise<DeleteUnsyncedOrdersResponse> => {
    return apiClient.post<DeleteUnsyncedOrdersResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.DELETE_UNSYNCED_ORDERS,
        request,
        { headers: { 'X-Store-Brand-Id': storeBrandId } }
    );
};

export const updateUnsyncedOrders = async (
    request: UpdateUnsyncedOrdersRequest,
    storeBrandId: string
): Promise<UpdateUnsyncedOrdersResponse> => {
    return apiClient.post<UpdateUnsyncedOrdersResponse>(
        API_ENDPOINTS.STORE_MANAGEMENT.UPDATE_UNSYNCED_ORDERS,
        request,
        { headers: { 'X-Store-Brand-Id': storeBrandId } }
    );
};
